/* ============
 * Axios
 * ============
 *
 * Promise based HTTP client for the browser and node.js.
 * Because Vue Resource has been retired, Axios will now been used
 * to perform AJAX-requests.
 *
 * https://github.com/mzabriskie/axios
 */

import Vue from 'vue';
import Axios from 'axios';
import store from '@/store';
import { guestMapping } from '@/utils/endpoint';


Axios.defaults.baseURL = process.env.API_LOCATION;
Axios.defaults.headers.common.Accept = 'application/json';
Axios.interceptors.request.use(
  (config) => {
    // start of check for internal accessing guest
    // if the api is one that can be used by both internal and customer
    // and the current user is internal, do not create authorization error
    let isGuestAPI = false;
    if (localStorage.getItem('is_internal') === 'true') {
      guestMapping.forEach((m) => {
        if (config.url.includes(m))
          isGuestAPI = true;
      });
    }
    if (isGuestAPI && localStorage.getItem('is_internal') === 'true')
      return config;
    // end of check for internal accessing guest
    if (localStorage.getItem('access_token')) {
      if (store.state.broker.customerAccessToken !== '')
        config.headers.Authorization = `Bearer ${store.state.broker.customerAccessToken}`;
      else
        config.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
    }
    return config;
  }, err => Promise.reject(err),
);
Axios.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response.status === 500)
      window.location = '/error';
    if (error.response.status === 401) {
      store.dispatch('auth/logout', {
        cbSuccess: () => {
          setTimeout(() => { window.location = '?login=true'; }, 300);
        },
      });
    } if (error.response.status === 503)
      store.dispatch('auctioneer/showAuctionPausedStatus', true);
    return Promise.reject(error);
  });

// Bind Axios to Vue.
Vue.$http = Axios;
Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return Axios;
  },
});



// WEBPACK FOOTER //
// ./src/plugins/axios.js